module.exports = __webpack_public_path__ + "img/header-img.58abbc16.png";